import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-swigit-bundle',
  templateUrl: './swigit-bundle.component.html',
  styleUrls: ['./swigit-bundle.component.scss']
})
export class SwigitBundleComponent implements OnInit {

  //#region life-cycle methods

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  //#endregion

  //#region public methods

  public onImageClick() {
   // console.log('das');
    this.router.navigateByUrl(`/single?title=celebbroadway&domain=celebration`);
  }

  //#endregion

}
